<template>
  <div>
    <el-form size="small" ref="form" :model="form" :rules="rules" label-width="120px" label-suffix=":">
      <el-form-item align="left" label="Version" required>
        <!-- <el-col :span="8">
  <el-form-item prop="version"><el-input v-model.number="form.version" @change="checkOldVersion"></el-input></el-form-item>
</el-col>	 -->
        <el-col :span="3">
          <el-form-item prop="pos1">
            <el-input oninput="if(value.length>2)value=value.slice(0,2)" v-model.number="form.pos1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="pos2">
            <el-input oninput="if(value.length>2)value=value.slice(0,2)" v-model.number="form.pos2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="pos3">
            <el-input oninput="if(value.length>2)value=value.slice(0,2)" v-model.number="form.pos3"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1">
          <p>.</p>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="pos4">
            <el-input oninput="if(value.length>2)value=value.slice(0,2)" v-model="form.pos4"></el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item align="left" label="Selct File">
        <label style="margin-left:20px;width: 100px;"
               class="float-left btn-block re-upload-img-btn">
          upload file
          <input ref="file" accept="" type="file" @change="otaFileChange()" class="re-upload-img"/>
        </label>
      </el-form-item>
      <el-form-item  align="left">
        <label v-if="filename!=''" style="width: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-html="'file:'+filename"></label>
      </el-form-item>
      <el-form-item align="left" label="Last Version" prop="lastVersion">
        <el-col :span="12">
          <el-autocomplete
            class="inline-input"
            v-model="form.lastVersion"
            :fetch-suggestions="oldVersionSearch"
            placeholder="Please Input Version"
            :trigger-on-focus="false"
            @select="lastVersionSelect"
          >
          </el-autocomplete>
        </el-col>
      </el-form-item>
      <el-form-item align="left" label="strategy">
        <el-select v-model="form.strategy" placeholder="strategy" @change="handleStrategic">
          <el-option label="direct" value="1"></el-option>
          <el-option label="prompt" value="2"></el-option>
        </el-select>
      </el-form-item>
   <!--   <el-form-item align="left" label="md5">
        <el-input v-model="form.md5" placeholder="md5"></el-input>
      </el-form-item>-->
      <el-form-item align="left" label="uuids">
        <el-input type="textarea" v-model="form.uuids" placeholder="uuids"></el-input>
      </el-form-item>
      <el-form-item align="left" label="description">
        <el-input type="textarea" v-model="form.description" ></el-input>
      </el-form-item>
      <el-form-item align="right">
        <el-button @click="goBack" plain>Back</el-button>
        <el-button class="el-button--primary" @click="submit('form')">Save</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style scoped>
  .title {
    margin: 40px 0;
  }

  .textarea-wrap >>> textarea {
    height: 200px;
  }

  .old-version-list .el-checkbox {
    display: block;
    margin-left: 0;
  }

  .limit-uuids {
    display: block;
  }
</style>

<script>
  export default {
    props: {
      closeDialog: Function,
      dialogSucc: Function
    },
    data () {
      return {
        old_versions: [],
        filename:'',
        pre:'',
        form: {
          pos1: '',
          pos2: '',
          pos3: '',
          pos4: '',
          version: '',
          url: '',
          lastVersion: 'ALL',
          description: '',
          strategy: '1',
         // md5:'',
          uuids:'',
          // old_versions: [],
          // del_old_versions: [],
          otaFile: '',
        },
        rules: {
          pos1: [
            {required: true, message: 'please input', trigger: 'blur'},
            {type: 'number', message: 'please input number', trigger: 'blur'},
          ],
          pos2: [
            {required: true, message: 'please input', trigger: 'blur'},
            {type: 'number', message: 'please input number', trigger: 'blur'},
          ],
          pos3: [
            {required: true, message: 'please input', trigger: 'blur'},
            {type: 'number', message: 'please input number', trigger: 'blur'},
          ],
          pos4: [
            {required: true, message: 'please input', trigger: 'blur'},
            {pattern:/^\d*$/,message: 'please input number', trigger: 'blur'}
          ],
          strategy: [{required: true, message: 'Please select an upgrade strategy!', trigger: 'change'}],
          is_quiet: [{required: true, message: 'Please choose whether to be silent!', trigger: 'change'}]
        }
      }
    },
    created () {
      this.getOldVersions()
    },
    mounted () {

    },
    methods: {
      goBack () {
        this.$emit('closeDialog')
      },
      otaFileChange () {
        console.log('otaFileChange')
        this.form.otaFile = this.$refs.file.files[0]
        this.filename=this.$refs.file.files[0].name
        this.$refs.file.value=''
        this.uploadOta()
      },
      uploadOta () {
        if (!this.form.otaFile) {
          return this.$message.warning('Please select a file!')
        }
        console.log('this.form.otaFile:', this.form.otaFile)
        var formData = new FormData()
        formData.append('file', this.form.otaFile)
        formData.append('type', 'ota')

        // 黑幕
        const loading = this.$util.loading('loading...')
        this.$api.rootV1.post('/common/uploadDefault', formData, (res) => {
          loading.close()
          console.log('upload res:', res)
          if (res.errcode === 0) {
            this.$message.success('upload success')
            this.form.url = res.data.url
          } else {
            this.$message.error('upload fail')
          }
        })
      },
      getOldVersions () {
        this.$api.rootV1.get('/web/ota/getVersions', {}, (res) => {
          console.log('getVersions res:', res)
          let list = res.data.versions
          this.old_versions = list
          // list.forEach( function(item, index) {
          //     this.old_versions_save.push(item.version)
          // });
        })
      },
      // 版本是否足够高
      checkOldVersion () {
        let pass = true
        let arr = []
        const version = `${this.form.pos1}.${this.form.pos2}.${this.form.pos3}.${this.form.pos4}`
        const versionNum = version.split('.').join('') * 1
        if (this.old_versions.length > 0) {
          this.old_versions.forEach(item => {
            const oldVersion = item.version
            const oldVersionNum = oldVersion.split('.').join('') * 1
            if (oldVersionNum >= versionNum) {
              pass = false
            }
          })
        }

        return pass
      },
      handleStrategic () {
        // if (this.old_versions.length !== 0 && this.formData.old_versions.length === 0) {
        // 	this.formData.strategy = ''
        // 	return this.$message.warning('选择策略，要选定旧版本')
        // }
      },
      oldVersionSearch (queryString, cb) {
        const versions = this.old_versions
        console.log('versions:', versions)
        var results = queryString ? versions.filter(this.createVersionFilter(queryString)) : versions
        // 调用 callback 返回建议列表的数据
        console.log('results:', results)
        results.forEach(item => item.value = item.version)
        results.unshift({value: 'ALL'})
        cb(results)
      },
      createVersionFilter (queryString) {
        return (version) => {
          return (version.version.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
        }
      },
      lastVersionSelect (item) {
        console.log('lastVersionSelect item:', item)
        this.form.lastVersion = item.value
      },
      async submit (formName) {
        if (!this.form.url.trim()) {
          return this.$message.warning('Please upload the firm file')
        }

        if (!this.checkOldVersion()) {
          return this.$message.warning('This version is not big enough')
        }

        // if (this.old_versions.length !== 0 && this.form.old_versions.length>0 && !this.form.strategy) {
        // 	return this.$message.warning('选择旧版本同时要选择策略')
        // }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form.version = this.form.pos1 + '.' + this.form.pos2 + '.' + this.form.pos3 + '.' + this.form.pos4
            if (!this.form.lastVersion) {
              return this.$message.error('Need a last version')
            }
            let param=JSON.parse(JSON.stringify(this.form))
            param.uuids=this.pre+param.uuids
            let params = {
              form: param,
            }
            //return console.log(JSON.stringify(params))
            // 黑幕
            const loading = this.$loading({
              lock: true,
              text: 'loading......',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })

            this.$api.rootV1.post('/web/ota/versionAdd', params, (res) => {
              loading.close()
              if (res.errcode === 0) {
                this.$emit('dialogSucc')
              } else {
                this.$message.warning(res.errmsg)
              }
            },(res) => {
                this.$message.warning(res.errmsg)
                loading.close()
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },

    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/main/ota/OTAAdd.vue